export const MOCK_PROJECT_DATA = [
  {
    id: 1,
    name: 'Project 1',
    status: 1,
    responsiblePerson: 'Person 1',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 35,
  },
  {
    id: 2,
    name: 'Project 2',
    status: 3,
    responsiblePerson: 'Person 2',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 28,
  },
  {
    id: 3,
    name: 'Project 3',
    status: 1,
    responsiblePerson: 'Person 3',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 50,
  },
  {
    id: 4,
    name: 'Project 4',
    status: 4,
    responsiblePerson: 'Person 4',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 10,
  },
  {
    id: 5,
    name: 'Project 5',
    status: 2,
    responsiblePerson: 'Person 5',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 20,
  },
  {
    id: 6,
    name: 'Project 6',
    status: 1,
    responsiblePerson: 'Person 6',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 30,
  },
  {
    id: 7,
    name: 'Project 7',
    status: 1,
    responsiblePerson: 'Person 7',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 40,
  },
  {
    id: 8,
    name: 'Project 8',
    status: 3,
    responsiblePerson: 'Person 8',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 50,
  },
  {
    id: 9,
    name: 'Project 9',
    status: 2,
    responsiblePerson: 'Person 9',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 60,
  },
  {
    id: 10,
    name: 'Project 10',
    status: 4,
    responsiblePerson: 'Person 10',
    startDate: '2021-01-01',
    endDate: '2021-01-01',
    totalSaleOrder: 70,
  },
]
